import React, { useState, useMemo } from "react";
import { motion } from "framer-motion";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";

const ImageGallery = ({ images }) => {
    const safeImages = useMemo(
        () => (Array.isArray(images) ? images.filter(Boolean) : []),
        [images]
    );
    const [currentIndex, setCurrentIndex] = useState(0);

    const nextImage = () => {
        if (safeImages.length === 0) return;
        setCurrentIndex((prev) => (prev + 1) % safeImages.length);
    };

    const prevImage = () => {
        if (safeImages.length === 0) return;
        setCurrentIndex(
            (prev) => (prev - 1 + safeImages.length) % safeImages.length
        );
    };

    if (safeImages.length === 0) {
        return (
            <div className="relative aspect-video bg-gray-100 rounded-lg overflow-hidden" />
        );
    }

    return (
        <div className="relative aspect-video bg-gray-100 rounded-lg overflow-hidden">
            {/* Main Image */}
            <motion.img
                key={currentIndex}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                src={safeImages[currentIndex]}
                alt={`Gallery image ${currentIndex + 1}`}
                className="w-full h-full object-cover"
                loading="lazy"
                decoding="async"
            />

            {/* Navigation Buttons */}
            {safeImages.length > 1 && (
                <>
                    <button
                        onClick={prevImage}
                        className="absolute left-2 top-1/2 -translate-y-1/2 p-2 rounded-full bg-white/80 hover:bg-white shadow-lg transition-colors"
                    >
                        <IoChevronBack size={24} />
                    </button>
                    <button
                        onClick={nextImage}
                        className="absolute right-2 top-1/2 -translate-y-1/2 p-2 rounded-full bg-white/80 hover:bg-white shadow-lg transition-colors"
                    >
                        <IoChevronForward size={24} />
                    </button>
                </>
            )}

            {/* Image Counter */}
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/60 text-white px-3 py-1 rounded-full text-sm">
                {currentIndex + 1} / {safeImages.length}
            </div>
        </div>
    );
};

export default ImageGallery;
